<!--
리턴라벨 보관여부 input 컴포넌트
 - input 으로 표현될때는 코드표와 다른 순서와 이름으로 표시될 필요가 있어서.. 따로 작성함
-->
<template>
    <div>
        <div class="uk-flex uk-flex-middle bg-sky-700">
            <div class="header mr-1rem text-white p-0d5rem ">
                리턴라벨
            </div>
            <div class="options uk-width-expand">
                <label
                    class="mr-1rem"
                    :class="'value-'+option.val"
                    v-for="(option, index) in options"
                    :key="index"
                >
                    <input
                        class="uk-radio"
                        type="radio"
                        :name="name"
                        :value="option.val"
                        v-model="radioValue"
                        @change="updateValue"
                    />
                    {{ option.name }}


                </label>

            </div>
        </div>

        <div class="desc">
            <strong>[주의] Return Label  & Invoice & 도착박스 트래킹 Label</strong>
            반드시 <br />
            <strong>오류상품과 같이 보관</strong>
            !!
        </div>

    </div>


</template>

<script>
export default {
    props: {
        // 라디오 name 속성
        name: String,

        // 초기값
        initValue: Number,
    },
    data: function () {
        return {
            // 선택값
            radioValue: this.initValue,

            // 옵션배열
            options: [
                {val: 0, name: '없음(X)'},
                {val: 1, name: '있음(O)'},

            ],
        };
    },
    watch: {
        // 부모로부터 전달받은 초기값 변경되면 라디오선택값 변경시켜줌
        initValue: function (val) {
            this.radioValue = val;
        }
    },
    methods: {
        updateValue: function (event) {
            // 선택된 라디오버튼에서만 이벤트 발생시킴
            if (event.target.checked) {
                this.$emit('change', this.radioValue);
            }
        }
    },
}
</script>


<style lang="scss" scoped>
.header {
    font-size: 1.25rem;
    font-weight: bold;
}

.options {


    //

    input.uk-form-large[type=radio] {
        height: 1.25rem !important;
        width: 1.25rem !important;
    }

    label {
        cursor: pointer;
//        font-size: 1rem !important;
        .uk-radio {
            border: 1px solid #fff;

            &:checked {
                border: 2px solid #fff;
            }
            &:hover {
                box-shadow: 0 0 0 max(4px, 2px) #fff;
            }
        }


    }


    // 없음
    .value-0 {
        color: #fff;
        font-weight: bold;
        font-size: 1.5rem;
    }

    // 있음
    .value-1 {
        //color: #000;
        font-weight: bold;
        font-size: 1.5rem;
        color: #fde047;

        & .uk-radio {
            &:checked {
                border: 2px solid #fde047;
            }
            &:hover {
                box-shadow: 0 0 0 max(4px, 2px) #fde047;
            }
        }

    }
}


.desc {
    text-align: center;
    padding: 0.25rem;
    font-size: 0.875rem;
    background-color: #fff;
    color: #000;
//    font-weight: bold;

    strong {
        color: #ee395b;
        font-weight: normal;
    }
}
</style>
